import { Button, ButtonProps } from "@mui/material";
import { PropsWithChildren } from "react";
import { Control, FieldValues, useFormState } from "react-hook-form";

type Props<T extends FieldValues = FieldValues> = {
    color?: ButtonProps["color"];
    control: Control<T>;
    fullWidth?: boolean;
    startIcon?: ButtonProps["startIcon"];
    variant?: ButtonProps["variant"];
};

export default function GaiaHookFormSubmitButton<T extends FieldValues = FieldValues>({
    color = "primary",
    control,
    startIcon,
    children,
    fullWidth = true,
    variant = "contained",
}: PropsWithChildren<Props<T>>) {
    const { isDirty, isSubmitting } = useFormState({ control });

    return (
        <Button
            color={color}
            disabled={!isDirty}
            fullWidth={fullWidth}
            loading={isSubmitting}
            startIcon={startIcon}
            type="submit"
            variant={variant}
        >
            {children}
        </Button>
    );
}
